// A click-through target safe to place in an `href`, or null to drop it. Media `link_url` is stored
// UNSANITIZED by every writer (the v6 sync ingest sanitizes only RichText/Quote text; editor,
// MCP, and RSS-content-stream media all reach the renderers raw), and both media renderers put it
// into an `href` — the inline React view (React does NOT block `javascript:` hrefs) and the
// slideshow (raw string interpolation). So validate at the sink: allow only absolute http(s) and
// strict root-relative paths (never `//` or `/\`, which smuggle to another origin); drop the rest.

// Browsers strip Tab/LF/CR (and other C0 controls, code points below 0x20) from URLs, so a value
// like `/<TAB>/evil.com` collapses to the protocol-relative `//evil.com` — a cross-origin open
// redirect. A literal space (0x20) is fine; anything below it never belongs in a stored link.
function hasControlChar(value: string): boolean {
  for (let i = 0; i < value.length; i++) {
    if (value.charCodeAt(i) < 0x20) return true
  }
  return false
}

export function safeLinkUrl(url: unknown): string | null {
  if (typeof url !== 'string' || url === '' || hasControlChar(url)) return null
  if (/^https?:\/\//i.test(url)) return url
  if (/^\/(?![/\\])/.test(url)) return url
  return null
}
